import { useDispatch } from "react-redux";
import { updateStaticPageDescription } from "../../stores/customForm/customFormActions";
import DescriptionField from "./DescriptionField";

const StaticPage = ({ pageKey, descriptions = {} }) => {
  const dispatch = useDispatch();

  const handleDescriptionChange = (locale, description) => {
    dispatch(updateStaticPageDescription(pageKey, locale, description));
  };

  // Build page object for DescriptionField
  const page = {};
  if (window.available_locales) {
    window.available_locales.forEach((locale) => {
      page[`description_${locale}`] = descriptions[locale];
    });
  }

  return (
    <div className="ibox">
      <div className="ibox-title">
        <h5>{pageKey} page</h5>
      </div>
      <div className="ibox-content">
        <DescriptionField
          key={pageKey}
          pageKey={pageKey}
          handleDescriptionChange={handleDescriptionChange}
          page={page}
        />
      </div>
    </div>
  );
};

export default StaticPage;
